module.exports = __webpack_public_path__ + "static/img/wisdomZhili2.de4a3fc8.png";